export interface PaymentTermFields {
  base_date?: 'bl_date' | 'invoice_date' | null;
  due_days?: number | null;
  due_date_rule?: string | null;
}
export function paymentTermSummary(row: { base_date?: unknown; due_days?: unknown; due_date_rule?: unknown }): string {
  if ((row.base_date === 'bl_date' || row.base_date === 'invoice_date') && typeof row.due_days === 'number' && Number.isInteger(row.due_days) && row.due_days >= 0 && row.due_days <= 3650)
    return `${row.due_days} days after ${row.base_date === 'bl_date' ? 'B/L date' : 'Invoice date'}`;
  return typeof row.due_date_rule === 'string' && row.due_date_rule ? row.due_date_rule : 'Not recorded';
}
export function derivedDueDate(value: unknown, status?: unknown): string {
  return value == null || value === '' || value === 'not_evaluated' || status === 'not_evaluated'
    ? 'Not evaluated — the required payment term or base date is unavailable.'
    : String(value).slice(0, 10);
}
